// generatedNotifyHref.js — where a BUILT app's notification opens (persona
// round 5, marcus, shot 032: "New open-house lead: Dana Whitfield" arrived in
// his Inbox, and a tap only marked it read).
//
// A built app notifies with a declarative fetch — `{ method: 'insert', from:
// 'notifications', on: 'submit' }` — so the payload is the form's data: a
// title and a body, never an `href`. The server stores `href: payload.href ??
// null`, and the shared rule (notificationHrefOf) opens nothing for a row with
// no href. The app itself is the place the news is about, so a notification
// with no href of its own gets the app's page: the path it was sent from (its
// own `/x/<key>` route once installed), or — in the builder's preview — the
// build thread (`/add-app?thread=<id>`, never a blank builder). An href the app
// set itself is kept; the server still checks it is an in-app path.
//
// Pure: (data, root) → data, never mutated. Called from functions/index.js
// _rewriteFetchDecls, which wraps the decl's `transform`.
export const generatedNotifyHref = (data, root) => {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return data
  if (typeof data.href === 'string' && data.href.trim()) return data
  const r = root && typeof root === 'object' ? root : {}
  const path = String(r.currentPath || '').split(/[?#]/)[0]
  if (!path || path.charAt(0) !== '/' || path.startsWith('//')) return data
  const thread = r._addAppProjectId ? String(r._addAppProjectId) : ''
  const href =
    /\/add-app$/.test(path) && thread ? path + '?thread=' + encodeURIComponent(thread) : path
  return { ...data, href }
}
